import React, { useState, useEffect, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Container, Row, Col, Button, Form, Alert, Stack, Modal, Spinner } from "react-bootstrap";
import LoggedInContainer from "../../layout/LoggedInContainer";
import { useNavigate } from "react-router-dom";
import { canViewVoluntaryData, formatToAEST, isReportEditable } from "../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../..";
import {
    getMediaFiles,
    getConsignmentDaysForConsignmentID,
    getConsignmentDecksWithoutBridgeForConsignmentID,
    getSpeciesAndClassesForConsignmentID,
    updateMediaMeta,
    deleteMediaFiles,
} from "../../api/apiAccess";
import ReadWriteFormSelect from "../../components/ReadWriteElements/ReadWriteFormSelect"
import ReadWriteFormControl from "../../components/ReadWriteElements/ReadWriteFormControl"
import ReadWriteFormRadio from "../../components/ReadWriteElements/ReadWriteFormRadio"
import ReadWriteButton from "../../components/ReadWriteElements/ReadWriteButton"
import Dummy from "../../assets/no-picture-available.png";
import Swal from "../../utils/Swal";

const MediaEditPage = (props) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const userCtx = useContext(UserContext);

    const { mediametaID } = useParams();

    const [loading, setIsLoading] = useState(false);

    const [mediaFiles, setMediaFiles] = useState({});

    const [showVoluntaryData, setShowVoluntaryData] = useState(false);
    const [show, setShow] = useState(false);
    const [urlImage, setUrlImage] = useState(null);
    const [urlVideo, setUrlVideo] = useState(null);
    const [imgTitle, setImageTitle] = useState(null);
    const [mediaMeta, setMediaMeta] = useState(state?.mediaMeta);
    const [deletedFileIds, setDeletedFileIds] = useState([]);

    const [voyageDays, setVoyageDays] = useState([]);
    const [decks, setDecks] = useState([]);
    const [speciesClassOptions, setSpeciesClassOptions] = useState([]);

    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [isSaving, setIsSaving] = useState(false);


    console.log("MediaEditPage", mediametaID, mediaMeta);

    const handleClose = () => setShow(false);

    const handleShow = (e, item) => {
        e.preventDefault();

        if (item.video_src) {
            setUrlVideo(item.video_src);
            setUrlImage(null);
        } else {
            setUrlImage(item.img_src);
            setUrlVideo(null);
        }
        // setImageTitle(title);
        //console.log(src);
        setShow(true);
    };

    const handleRemove = (item) => {
        Swal.ConfirmationDialog(`Are you sure you want to delete this media file? This is an irreversible action and LiveCorp cannot recover the media`, "Delete", async () => {
            await deleteMediaFiles([item.id])
            setDeletedFileIds([...deletedFileIds, item.id]);
        });

    }

    const goBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        let lCanView = canViewVoluntaryData(userCtx.user);
        setShowVoluntaryData(lCanView);
    }, [userCtx.user]);

    const fetchMediaUrls = async () => {
        let mediaFiles = (await getMediaFiles(mediametaID)).data;

        setMediaFiles(mediaFiles);
        setIsLoading(false);
    };

    const fetchVoyageDays = async () => {
        getConsignmentDaysForConsignmentID(mediaMeta.consignmentID).then((response) => {
            const maxDay = Math.max(...response.data.map(o => o.dayNumber));

            let N = 7;
            if(maxDay >= 5 && maxDay < 13) N = 14;
            else if(maxDay >= 13) N = 21;

            const arr = Array.from({length: N}, (_, i) => ({id: i + 1, dayNumber: i + 1}));
            setVoyageDays(arr);
            setMediaMeta({...mediaMeta, voyageDayID: arr.find(o => o.dayNumber === mediaMeta.dayNumber)?.id});
        })
    }

    const fetchDecks = async () => {
        getConsignmentDecksWithoutBridgeForConsignmentID(mediaMeta.consignmentID).then((response) => {
            setDecks(response.data);
        })
    }

    const fetchSpeciesAndClasses = async () => {
        getSpeciesAndClassesForConsignmentID(mediaMeta.consignmentID).then((response) => {
            setSpeciesClassOptions(response.data);
        })
    }

    useEffect(() => {
        fetchMediaUrls();
        fetchVoyageDays();
        fetchDecks();
        fetchSpeciesAndClasses();
    }, [mediametaID])

    const getItems = () => {
        let image = [];
        if (mediaFiles?.photos?.length > 0 || mediaFiles?.videos?.length > 0) {
            for (let i = 0; i < mediaFiles.photos?.length; i++) {
                if (!deletedFileIds.includes(mediaFiles.photos[i].id)) {
                    image.push(
                        {
                            id: mediaFiles.photos[i].id,
                            img_src: mediaFiles.photos[i].url,
                        }
                    )
                }
            }

            for (let i = 0; i < mediaFiles.videos?.length; i++) {
                if (!deletedFileIds.includes(mediaFiles.videos[i].id)) {
                    image.push(
                        {
                            id: mediaFiles.videos[i].id,
                            img_src: mediaFiles.videos[i].thumbnailUrl,
                            video_src: mediaFiles.videos[i].url,
                        }
                    )
                }
            }
        }

        return image;
    }

    const update = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setShowSuccessMsg(false);
        setShowErrorMsg(false);

        try {
            const essentialMediaMeta = {
                hashID: mediaMeta.hashID,
                deckNumber: mediaMeta.deckNumber,
                dayNumber: mediaMeta.dayNumber,
                speciesID: mediaMeta.speciesID,
                classID: mediaMeta.classID,
                numberOfHead: mediaMeta.numberOfHead,
                penName: mediaMeta.penName,
                comment: mediaMeta.comment,
                voyageStatusID: mediaMeta.voyageStatusID
            };

            const metaResponse = await updateMediaMeta(essentialMediaMeta);
            if (metaResponse.status !== 200) {
                throw new Error("Failed to update media metadata.");
            }

            setShowSuccessMsg(true);
        } catch (error) {
            console.error(error);
            setShowErrorMsg(true);
        } finally {
            setIsSaving(false);
        }
    };


    return (
        <LoggedInContainer>
            <Container fluid className="p-0" style={{ backgroundColor: "#F5F5F5" }}>
                <Row className="upper-panel mx-0" style={{ position: "relative" }}>
                    <Col>
                        <Container>
                            <Row>
                                <Col xs={12} style={{ marginTop: "75px" }}>
                                    <Button variant="back" onClick={() => goBack()} style={{ display: "inline", position: "absolute", top: "75px" }}>
                                        <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: "5px" }} />
                                        Back
                                    </Button>
                                    <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", display: "inline" }}>
                                        <div style={{ lineHeight: "53px", fontSize: "35px" }}>
                                            Edit Media
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>

                <Container className="py-4 px-5 form-container-full">

                    {loading === true ? (
                        <Row>
                            <Col>
                                <div className="text-center pt-5">
                                    <Spinner className="mx-auto" />
                                    <div className="mx-auto">Loading data...</div>
                                </div>
                            </Col>
                        </Row>
                    ) :
                        <Row>
                            <Col>
                                <div className="green-underline-heading">Location Details</div>
                                <Row>
                                    <div className="media-gallery-content">
                                        {mediaFiles && getItems().map((item, idx) => (
                                            <div key={idx} className="media-gallery-img-box" style={{ position: 'relative' }}>
                                                {/* Delete icon button */}
                                                <button className="delete-btn"
                                                    onClick={() => handleRemove(item)}
                                                    title="Remove"
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>

                                                <a href={item.img_src} onClick={e => handleShow(e, item)}>
                                                    <img
                                                        src={item.img_src}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = Dummy;
                                                        }}
                                                        style={{ width: '100%', height: 'auto', display: 'block' }}
                                                    />
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="text-13-400 secondary-grey">
                                        <div className="field-label">
                                            Date/time captured
                                        </div>
                                        <Row>
                                            <Col>{formatToAEST(mediaMeta?.captureDateUTC, mediaMeta?.timeZone)}</Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col className="text-13-400 secondary-grey">
                                        <div className="field-label">
                                            Capture intended for
                                        </div>
                                        <Row>
                                            {mediaMeta?.isExporterOnly ? <Col>Exporter</Col>  : <Col>Department</Col>}
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col xs={2}>
                                        <div className="field-label">Reporting Day</div>
                                        <Form.Group>
                                            <ReadWriteFormSelect
                                                className="text-13-400 secondary-grey"
                                                value={mediaMeta?.voyageDayID}
                                                onChange={(e) => {
                                                    setMediaMeta({
                                                        ...mediaMeta,
                                                        voyageDayID: e.target.value,
                                                        dayNumber: Number(e.target.options[e.target.selectedIndex].text)
                                                    })
                                                }}
                                            >
                                                {voyageDays.map((opt, i) => {
                                                    return (
                                                        <option key={`day_opt_${i}`} value={opt.id}>
                                                            {opt.dayNumber}
                                                        </option>
                                                    );
                                                })}
                                            </ReadWriteFormSelect>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col xs={2}>
                                        <div className="field-label">Deck</div>
                                        <Form.Group>
                                            <ReadWriteFormSelect
                                                className="text-13-400 secondary-grey"
                                                value={mediaMeta?.deckID}
                                                onChange={(e) => setMediaMeta({
                                                    ...mediaMeta, deckID: e.target.value,
                                                    deckNumber: e.target.options[e.target.selectedIndex].text
                                                })}
                                            >
                                                {decks.map((opt, i) => {
                                                    return (
                                                        <option key={`deck_opt_${i}`} value={opt.id}>
                                                            {opt.deckName}
                                                        </option>
                                                    );
                                                })}
                                            </ReadWriteFormSelect>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={2}>
                                        <div className="field-label">Pen</div>
                                        <Form.Group>
                                            <ReadWriteFormControl
                                                value={mediaMeta.penName}
                                                onChange={(e) => setMediaMeta({ ...mediaMeta, penName: e.target.value })}
                                                className="text-13-400 secondary-grey"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col xs={2}>
                                        <div className="field-label">No of head in pen</div>
                                        <Form.Group>
                                            <ReadWriteFormControl
                                                value={mediaMeta.numberOfHead}
                                                onChange={(e) => setMediaMeta({ ...mediaMeta, numberOfHead: e.target.value })}
                                                className="text-13-400 secondary-grey"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>


                                <Row className="mt-3">
                                    <Col xs={4}>
                                        <div className="field-label">Species/Class</div>
                                        <Form.Group>
                                            <ReadWriteFormSelect
                                                className="text-13-400 secondary-grey"
                                                value={mediaMeta?.classID + 10000 * mediaMeta?.speciesID}
                                                onChange={(e) => setMediaMeta({ ...mediaMeta, speciesID: Number(e.target.value) / 10000, classID: Number(e.target.value) % 10000 })}
                                            >
                                                {speciesClassOptions.map((opt, i) => {
                                                    return (
                                                        <option key={`sc_opt_${i}`} value={opt.id}>
                                                            {opt.speciesName + " - " + opt.className}
                                                        </option>
                                                    );
                                                })}
                                            </ReadWriteFormSelect>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col>
                                        <div className="medium-heading">Photo Category</div>
                                        <ReadWriteFormRadio
                                            type={`radio`}
                                            label={`General`}
                                            checked={mediaMeta.voyageStatusID === 1}
                                            className="text-13-400 secondary-grey"
                                            id="rdoVentilationIssue_No"
                                            onChange={() => {
                                                setMediaMeta({ ...mediaMeta, voyageStatusID: 1 });
                                            }}
                                        />
                                        <ReadWriteFormRadio
                                            type={`radio`}
                                            label={`Loading`}
                                            checked={mediaMeta.voyageStatusID === 2}
                                            className="text-13-400 secondary-grey"
                                            id="rdoVentilationIssue_Yes"
                                            onChange={() => {
                                                setMediaMeta({ ...mediaMeta, voyageStatusID: 2 });
                                            }}
                                        />
                                        <ReadWriteFormRadio
                                            type={`radio`}
                                            label={`Discharge`}
                                            checked={mediaMeta.voyageStatusID === 3}
                                            className="text-13-400 secondary-grey"
                                            id="rdoVentilationIssue_Yes"
                                            onChange={() => {
                                                setMediaMeta({ ...mediaMeta, voyageStatusID: 3 });
                                            }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-3">

                                    <Col>
                                        <div className="medium-heading">Comments</div>
                                        <ReadWriteFormControl
                                            className="text-13-400 secondary-grey"
                                            as="textarea"
                                            rows={3}
                                            value={mediaMeta?.comment}
                                            onChange={(e) => setMediaMeta({ ...mediaMeta, comment: e.target.value })}
                                        />
                                    </Col>
                                </Row>


                                <Row className="mt-4">
                                    <Col>
                                        {showSuccessMsg && <Alert variant="success">Media updated successfully</Alert>}
                                        {showErrorMsg && <Alert variant="danger">Error updating media</Alert>}
                                    </Col>
                                </Row>
                                {isReportEditable(userCtx, state.allowEditing) && !isSaving &&
                                    <Row className="mt-4">
                                        <Col>
                                            <Stack direction="horizontal" gap={2} style={{ justifyContent: "left" }}>

                                                <ReadWriteButton
                                                    writeonly={true}
                                                    variant="primary"
                                                    onClick={(e) => {
                                                        update(e);
                                                    }}
                                                    style={{ minWidth: "150px" }}
                                                >
                                                    Complete
                                                </ReadWriteButton>
                                            </Stack>
                                        </Col>
                                    </Row>
                                }


                            </Col>
                        </Row>

                    }

                    <Modal show={show} onHide={handleClose}>
                        <Modal.Body>
                            {urlImage &&
                                <img src={urlImage} alt={imgTitle} />
                            }
                            {urlVideo &&
                                <video
                                    width="100%"
                                    controls
                                    autoPlay
                                    style={{ borderRadius: '4px' }}
                                >
                                    <source
                                        src={urlVideo}
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </Container>
            </Container>
        </LoggedInContainer>
    );
};

export default MediaEditPage;
